import { useState } from 'react';
import { isNumber } from 'utils/validation';

type Options = {
  scrollToTopWhenMovingStep?: boolean;
};

const useStepper = (initialStep = 0, options?: Options) => {
  const [activeStep, setActiveStep] = useState(initialStep);

  const handleNext = (stepToJumpTo?: number) => {
    if (options?.scrollToTopWhenMovingStep) {
      window.scrollTo(0, 0);
    }

    if (isNumber(stepToJumpTo)) {
      setActiveStep(stepToJumpTo as number);
      return;
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => Math.max(prevActiveStep - 1, 0));

    if (options?.scrollToTopWhenMovingStep) {
      window.scrollTo(0, 0);
    }
  };

  return { activeStep, handleNext, handleBack };
};

export { useStepper };
